import React, { useEffect, useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { buttonClasses } from '../../utils/buttonStyles';
const STORAGE_KEY = 'aurevane-cookie-preferences';
interface Preferences {
  analytics: boolean;
}
export function CookiePreferences() {
  const [prefs, setPrefs] = useState<Preferences>({
    analytics: false
  });
  const [status, setStatus] = useState<'idle' | 'saved' | 'error'>('idle');
  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored) setPrefs(JSON.parse(stored) as Preferences);
    } catch {
      /* storage unavailable — keep defaults */
    }
  }, []);
  const save = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
      setStatus('saved');
    } catch {
      setStatus('error');
    }
  };
  return <section id="preferences" aria-labelledby="preferences-title" className="mt-16 rounded-2xl border border-plum/10 bg-white p-6 sm:p-8" data-id="element-405" data-mp="2jhywm2bollu9">
      <h2 id="preferences-title" className="text-2xl font-semibold text-aubergine" data-id="element-406" data-mp="3n3e4ajhoxgf9">
        Cookie preferences
      </h2>
      <ul className="mt-6 divide-y divide-plum/10 border-y border-plum/10" data-id="element-407" data-mp="3j2u93lgogmvr">
        <li className="flex items-start justify-between gap-6 py-5" data-id="element-408" data-mp="w7f5lqzorhy">
          <div data-id="element-409" data-mp="ud36wxp49q0">
            <p className="font-display font-semibold text-aubergine" data-id="element-410" data-mp="3s2qzbripttsx">Essential</p>
            <p className="mt-1 text-sm leading-relaxed text-plum/70" data-id="element-411" data-mp="3s0o3gquvt6ga">Required for the site to function, including remembering these preferences. Always on.</p>
          </div>
          <input type="checkbox" checked disabled aria-label="Essential storage, always on" className="mt-1 h-5 w-5 accent-copper" data-id="element-412" data-mp="2zfo4b9d9017f" />
        </li>
        <li className="flex items-start justify-between gap-6 py-5" data-id="element-413" data-mp="39c97rq9md495">
          <div data-id="element-414" data-mp="39a6acl6508ue">
            <label htmlFor="pref-analytics" className="font-display font-semibold text-aubergine" data-id="element-415" data-mp="39ag50m24n46f">
              Analytics
            </label>
            <p id="pref-analytics-desc" className="mt-1 text-sm leading-relaxed text-plum/70" data-id="element-416" data-mp="2gmk8piggzea6">
              Not currently in use. If analytics are added, they will only run when this is switched on.
            </p>
          </div>
          <input id="pref-analytics" type="checkbox" aria-describedby="pref-analytics-desc" checked={prefs.analytics} onChange={e => {
          setPrefs({
            analytics: e.target.checked
          });
          setStatus('idle');
        }} className="mt-1 h-5 w-5 cursor-pointer accent-copper" data-id="element-417" data-mp="phpf6l6gycpg" />
        </li>
      </ul>
      <div className="mt-6 flex flex-wrap items-center gap-4" data-id="element-418" data-mp="6kxxuhahm7o1">
        <button type="button" onClick={save} className={buttonClasses('dark', 'md')} data-id="element-419" data-mp="al829pimsq0s">
          Save Preferences
        </button>
        <p role="status" className="text-sm text-plum/70" data-id="element-420" data-mp="fmnohkwjp2kr">
          {status === 'saved' && <span className="inline-flex items-center gap-1.5" data-id="element-421" data-mp="1m16hkb4ek8ag">
              <CheckIcon className="h-4 w-4 text-copper" aria-hidden="true" data-id="element-422" data-mp="1qzq52fyn9s4x" />
              Preferences saved in this browser.
            </span>}
          {status === 'error' && <span className="text-danger" data-id="element-423" data-mp="1w5myl7tmbvfu">Your browser blocked saving preferences.</span>}
        </p>
      </div>
    </section>;
}